import { applyApiErrors } from "./applyApiErrors";

/**
 * Run a Create * mutation, toast success, and map API errors onto the drawer.
 *
 * @param {{
 *   request: function(): !Promise,
 *   notify: function({type: string, message: string}): void,
 *   setErrors: function(!Object): void,
 *   successMessage: string,
 *   onSuccess: (function(*): void)=
 * }} opts
 * @return {!Promise}
 */
export const saveQuickCreate = async ({
  request,
  notify,
  setErrors,
  successMessage,
  onSuccess,
}) => {
  try {
    const created = await request();
    notify({ type: "success", message: successMessage });
    onSuccess?.(created);
    return created;
  } catch (error) {
    applyApiErrors(error?.data, setErrors, notify);
    return undefined;
  }
};
